<template>
    <div class="p-col-12 p-md-12 p-lg-12">
        <page-header title="system-configuration.page-header"/>
        <div class="p-grid">
            <square-card title="system-configuration.user-list" link="userList" icon="pi pi-fw pi-user"/>
            <square-card title="system-configuration.login-page" link="login-page-configuration" icon="pi pi-fw pi-desktop"/>
            <square-card title="system-configuration.type-service" link="typeServiceList" icon="pi pi-fw pi-tags"/>
            <square-card title="system-configuration.quick-protocol-create" link="quickProtocolCreateList" icon="fas fa-tachometer-alt"/>
            <square-card title="system-configuration.letter" link="letterList" icon="fa fa-envelope-open-text"/>
            <square-card title="system-configuration.contract" link="contractList" icon="fa fa-file-contract"/>
            <square-card title="system-configuration.text-fragment" link="textFragmentList" icon="fas fa-money-check"/>
            <square-card title="system-configuration.budget-configuration" link="budgetConfigurationList" icon="fa-regular fa-newspaper"/>
            <square-card title="system-configuration.timeline-predefinition" link="timelinePredefinitionList" icon="fa-solid fa-bars-staggered"/>
        </div>
    </div>
</template>

<script>
    import PageHeader from "@/components/page/PageHeader";
    import SquareCard from "@/components/card/SquareCard";

    export default {
        name: "SystemConfiguration",
        components: {SquareCard, PageHeader}
    }
</script>

<style scoped>

</style>